module.exports = __webpack_public_path__ + "img/AFRICA_TROPICAL_OILS.ae409178.png";